import React from 'react';
import PropTypes from 'prop-types';
import '../asset/progress_bar.scss'

export default class ProgressBar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      'isInfinite': props.infinite,
      'currentPercentage': props.percentage || 0,
    };
  }

  componentWillReceiveProps(nextProps) {
    if ((this.props.infinite === true) && (nextProps.infinite === false)){
      this.infiniteBar.addEventListener('animationiteration', () => {
        if (this.props.infinite === false) {
          this.setState({
            'isInfinite': false,
            'currentPercentage': 0,
          })
        }
      });
    }else if ((this.props.infinite === false) && (nextProps.infinite === true)){
      this.setState({
        'isInfinite': true,
      })
    }
  }

  componentDidUpdate() {
    // To ensure the bar with percentage 0 is drawn already to achieve smooth transition
    if (this.state.currentPercentage !== this.props.percentage){
      setTimeout(() => {
        window.requestAnimationFrame(() => {
          this.setState({
            'currentPercentage': this.props.percentage,
          })
        })
      }, 0)
    }
  }

  render() {
    let progressBarStyle = {
      'height': `${this.props.height}rem`
    };
    let activeBarStyle = {
      'backgroundColor': `${this.props.activeColor}`
    };
    let finiteContainerStyle = {
      'left': `${-100 + this.state.currentPercentage}%`
    }
    return (
      <div className="progress-bar" style={ progressBarStyle } >
        <div
          className={`container ${this.state.isInfinite ? 'infinite' : ''}`}
          ref={(e) => { this.infiniteBar = e; }}
          style={ !this.state.isInfinite && finiteContainerStyle }
        >
          <div className="active" style={ activeBarStyle } />
          { this.props.hasTip &&
            <div className="tip" />
          }
        </div>
      </div>
    );
  }
}

ProgressBar.propTypes = {
  infinite: PropTypes.bool,
  percentage: PropTypes.number,
  height: PropTypes.number,
  activeColor: PropTypes.string,
  hasTip: PropTypes.bool
}

ProgressBar.defaultProps = {
  infinite: true,
  percentage: 0,
  height: 0.4,
  activeColor: "var(--color-gs00, #FFFFFF)",
  hasTip: false
};
